(function () {
  'use strict';

  var prefersHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  function initMediaCarousel(mediaEl) {
    if (!prefersHover.matches) return;

    var imgs = mediaEl.querySelectorAll('.at-sam-card__img');
    var count = imgs.length;
    if (count <= 1) return;

    function select(index) {
      for (var i = 0; i < imgs.length; i++) {
        imgs[i].classList.toggle('is-active', i === index);
      }
    }

    mediaEl.addEventListener('mousemove', function (e) {
      var rect = mediaEl.getBoundingClientRect();
      var x = e.clientX - rect.left;
      var w = rect.width;

      if (count === 2) {
        select(1);
      } else if (count === 3) {
        select(x < w / 2 ? 1 : 2);
      } else {
        if (x < w / 3) select(1);
        else if (x < (2 * w) / 3) select(2);
        else select(3);
      }
    });

    mediaEl.addEventListener('mouseleave', function () {
      select(0);
    });
  }

  function animateScrollLeft(el, to, duration) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.scrollLeft = to;
      return;
    }
    var from = el.scrollLeft;
    var delta = to - from;
    if (Math.abs(delta) < 1) return;
    if (el._atScrollRaf) cancelAnimationFrame(el._atScrollRaf);
    var start = null;
    function step(ts) {
      if (start == null) start = ts;
      var t = Math.min(1, (ts - start) / duration);
      // ease-out smooth (kaynak hissi)
      var eased = 1 - Math.pow(1 - t, 3);
      el.scrollLeft = from + delta * eased;
      if (t < 1) el._atScrollRaf = requestAnimationFrame(step);
      else el._atScrollRaf = null;
    }
    el._atScrollRaf = requestAnimationFrame(step);
  }

  function initIconsCarousel(iconsEl) {
    if (!prefersHover.matches) return;
    if (iconsEl.scrollWidth <= iconsEl.clientWidth + 4) return;

    iconsEl.addEventListener('mouseenter', function () {
      animateScrollLeft(iconsEl, iconsEl.scrollWidth - iconsEl.clientWidth, 900);
    });

    iconsEl.addEventListener('mouseleave', function () {
      animateScrollLeft(iconsEl, 0, 900);
    });
  }

  function initGridVideo(scope) {
    var videos = scope.querySelectorAll('.at-sam-grid-video__video');
    if (!videos.length) return;

    videos.forEach(function (video) {
      var play = function () {
        if (video.paused) {
          var p = video.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        }
      };

      play();

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) play();
              else video.pause();
            });
          },
          { threshold: 0.25 }
        );
        observer.observe(video);
      }
    });
  }

  /** Scroll parallax — satırlar Liquid'de render edilir, JS sadece kaydırır */
  function initScrollPromo(section) {
    var main = section.querySelector('[data-at-scroll-rows]');
    if (!main) return;

    var rows = main.querySelectorAll('.at-sam-col__promo-row');
    if (!rows.length) return;

    var parallax = parseFloat(section.dataset.parallax || '1.5');
    var maxTranslate = (-1 * parallax * 100) / (1 + parallax);

    function updateScroll() {
      var rect = section.getBoundingClientRect();
      var vh = window.innerHeight;
      var total = rect.height + vh;
      var scrolled = vh - rect.top;
      var progress = total > 0 ? scrolled / total : 0;
      progress = Math.max(0, Math.min(1, progress));

      for (var i = 0; i < rows.length; i++) {
        var startX = i % 2 === 0 ? maxTranslate : 0;
        var endX = i % 2 === 0 ? 0 : maxTranslate;
        var current = startX + (endX - startX) * progress;
        rows[i].style.transform = 'translateX(' + current + '%)';
      }
    }

    updateScroll();

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    window.addEventListener('scroll', updateScroll, { passive: true });
    window.addEventListener('resize', updateScroll);
  }

  function initCards(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-at-media-carousel]').forEach(initMediaCarousel);
    scope.querySelectorAll('[data-at-icons-carousel]').forEach(initIconsCarousel);
    initGridVideo(scope);
    scope.querySelectorAll('[data-at-scroll-promo]').forEach(initScrollPromo);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCards(document);
  });

  document.addEventListener('shopify:section:load', function (e) {
    initCards(e.target || document);
  });
})();
